import React, { useState } from 'react';
import {
  Box, Container, Typography, Card, CardContent, TextField,
  InputAdornment, IconButton, Divider
} from '@mui/material';
import { Visibility, VisibilityOff, Lock } from '@mui/icons-material';
import { motion } from 'framer-motion';
import axios from 'axios';
import baseUrl from '../../config/baseUrl';

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  
  let token = sessionStorage.getItem("user");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      let values = {
        token,
        oldPassword,
        newPassword,
        confirmPassword
      };

      const config = {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.post(`${baseUrl}/changePassword-merchant`, values, config);

      if(data.status === true) {
        alert(data.message);
        sessionStorage.removeItem("user");
        window.location.href = "/DepositPortal";
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="sm">
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <Box position="relative" textAlign="center" mb={-5}>
            <Box
              sx={{
                width: 70,
                height: 70,
                borderRadius: '50%',
                background: 'linear-gradient(to bottom right, #1CAAE8, #5C9CFF)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 0 20px rgba(0, 176, 155, 0.4)',
                mx: 'auto',
                position: 'relative',
                zIndex: 2,
                animation: 'pulse 2s infinite',
                mt: 2,
              }}
            >
              <Lock sx={{ fontSize: 36, color: '#fff' }} />
            </Box>
          </Box>

          <Card
            sx={{
              mt: 4,
              borderRadius: 4,
              background: 'rgba(255, 255, 255, 0.85)',
              backdropFilter: 'blur(12px)',
              border: '1px solid rgba(0,0,0,0.05)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.05)',
              overflow: 'hidden',
              px: { xs: 2, sm: 4 }, // Responsive padding
              py: { xs: 4, sm: 6 }, // Responsive padding
            }}
          >
            <CardContent>
              <Typography variant="h5" fontWeight={600} textAlign="center" color="primary" gutterBottom>
                Change Password
              </Typography>
              <Divider sx={{ my: 2 }} />

              {[{
                label: 'Old Password', value: oldPassword, setter: setOldPassword, show: showOld, setShow: setShowOld
              }, {
                label: 'New Password', value: newPassword, setter: setNewPassword, show: showNew, setShow: setShowNew
              }, {
                label: 'Confirm Password', value: confirmPassword, setter: setConfirmPassword, show: showConfirm, setShow: setShowConfirm
              }].map((item, i) => (
                <TextField
                  key={i}
                  fullWidth
                  variant="outlined"
                  label={item.label}
                  type={item.show ? 'text' : 'password'}
                  value={item.value}
                  onChange={(e) => item.setter(e.target.value)}
                  sx={{ mb: 3 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => item.setShow(!item.show)} edge="end">
                          {item.show ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              ))}

              <Box textAlign="center" mt={4}>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  type="submit"
                  style={{
                    background: 'linear-gradient(to bottom right, #1CAAE8, #5C9CFF)',
                    color: '#fff',
                    border: 'none',
                    padding: '12px 30px',
                    borderRadius: '30px',
                    fontWeight: 600,
                    fontSize: '1rem',
                    cursor: 'pointer',
                    boxShadow: '0 4px 20px rgba(0,176,155,0.3)',
                    transition: '0.3s all',
                  }}
                  onClick={handleSubmit}
                >
                  Update Password
                </motion.button>
              </Box>
            </CardContent>
          </Card>
        </motion.div>
      </Container>

      <style>
        {`
        @keyframes pulse {
          0% { box-shadow: 0 0 0 0 rgba(0,176,155, 0.4); }
          70% { box-shadow: 0 0 0 18px rgba(0,176,155, 0); }
          100% { box-shadow: 0 0 0 0 rgba(0,176,155, 0); }
        }
        `}
      </style>
    </Box>
  );
};

export default ChangePassword;
